let initItem = undefined;
const initializePerformanceTheme = Item => {
  initItem = Item;
};
const receivePerformanceItem = () => {
  return initItem;
}
module.exports = {
  initItem,
  initializePerformanceTheme,
  receivePerformanceItem
}